<template>
  <div class="tw:p-4 tw:flex tw:flex-col tw:gap-y-3">
    <div
      v-for="level in levelsToShow"
      :key="`boost_level_${level}`"
      :data-testid="`boost_level_${level}`"
      class="tw:p-3 tw:shadow-lg tw:rounded-xl tw:hover:bg-blue-100"
      :class="
        selectedCommission === level
          ? 'tw:border-2 tw:border-blue-700 tw:bg-blue-100'
          : 'tw:bg-white tw:hover:cursor-pointer'
      "
      @click="() => selectCommission(level)"
    >
      <div class="tw:flex tw:items-center tw:w-full">
        <input
          type="radio"
          :value="level"
          :id="level"
          :checked="selectedCommission === level"
          @change="selectCommission(level)"
          class="tw:cursor-pointer tw:mr-4 tw:mb-1"
        />
        <div class="tw:w-full tw:text-[32px] tw:leading-[40px] tw:font-bold">
          {{ formatPercentage(language, level, 0, 0) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { useBoostLevels, useCampaign } from '@/components/rateConnect/queries'
import { formatPercentage } from '@/utils/Utility.ts'
import { useSmartBoost } from './useSmartBoost'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

const { selectCommission, selectedCommission } = useSmartBoost()
const { boostLevels } = useBoostLevels()
const { currentCommissionLevel } = useCampaign(selectedAccommodationId)
const { language } = useSessionValues()

const levelsToShow = computed(() => boostLevels.value?.filter(level => level > currentCommissionLevel.value))
</script>
